// import { Link } from "react-router-dom";
// import { DASHBOARD_LOAN_DETAILS } from "routes";
import { Statuslabel } from "./style"

export const STAFFCOLUMNS = [
	{
		title: "ID",
		render: (rowIndex,originalRow,index) => 1 + index
	},
	{
		title: "First Name",
		render: (_,originalRow) => (originalRow?.first_name ? originalRow?.first_name : "Not Provided")
	},
	{
		title: "Last Name",
		render: (_,originalRow) => (originalRow?.surname ? originalRow?.surname : "Not Provided")
	},
	{
		title: "Email",
		dataIndex: "email"
	},
	{
		title: "Role",
		render: (_,originalRow) =>
			originalRow?.admin_role === "es"
				? "Super Admin"
				: originalRow?.admin_role === "lo"
					? "Loan Officer"
					: originalRow?.admin_role === "lph"
						? "Loan Processing Head"
						: originalRow?.admin_role === "la"
							? "Auditor"
							: originalRow?.admin_role === "fdo"
								? "Front Desk Officer"
								: originalRow?.admin_role === "blog"
									? "Blogger"
									: originalRow?.admin_role === "acc"
										? "Accountant"
										: "NIL"
	},

	{
		title: "Status",
		render: (_,originalRow) => (
			<Statuslabel status={originalRow?.status}>
				<p className="text__value">
					{originalRow?.status === "activated"
						? "Active"
						: originalRow?.status === "pending"
							? "Pending"
							: originalRow?.status === "deactivated" || originalRow?.status === "suspended"
								? "Suspended"
								: "Inactive"}
				</p>
			</Statuslabel>
		)
	},
]
